import { DeclareMethod } from '/imports/methods';

/** Exchange a Google OAuth2 authorization code for a session. */
export const handleGoogleOauth2Code = DeclareMethod<{ code: string, referralCode?: string }, any>('handleGoogleOauth2Code');
/** Exchange a Discord OAuth2 authorization code for a session. */
export const handleDiscordOauth2Code = DeclareMethod<{ code: string, referralCode?: string }, any>('handleDiscordOauth2Code');